import FieldDefs from './AdsLinksFieldDefs';
import {doLangFields} from '../../../lib/ks-tools';
import AdsSelector from "./mixins/Selector";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    mixins: [AdsSelector],
    data () {
        return {
            fields: doLangFields(this, "lang.group_report.adslinks", FieldDefs),
            sortOrder: [
                {
                    field: 'link',
                    direction: 'asc'
                }
            ],
            moreParams: {},
            viewMode: '&view=links',
        }
    },
    computed: {
        self() {
            return this;
        },
    },

}
